export default function HeroSection() {
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5afe821d7233ccfcad715d1b70f7bf9c.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center gap-16">
        {/* Left text */}
        <div className="flex-1 text-center lg:text-left">
          <p className="text-xs uppercase tracking-[0.3em] text-white/60 mb-6 font-medium">
            iOS App Development
          </p>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extralight text-white leading-[1.08] mb-8">
            Modern iOS<br />
            <span className="font-semibold text-white">Applications</span><br />
            For Everyone
          </h1>
          <p className="text-base md:text-lg text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
            PRIMA d.o.o. is a team of experts crafting powerful, elegant iOS applications that elevate user experience and strengthen mobile security.
          </p>
          <p className="text-base md:text-lg text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-10">
            Our flagship products — VPN and Cleaner — are trusted by users worldwide to protect privacy and optimize device performance.
          </p>
          <button
            onClick={() => handleScroll('products')}
            className="inline-flex items-center gap-2 border border-white/40 text-white text-sm font-medium px-7 py-3 rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Explore Our Products
            <i className="ri-arrow-down-line" />
          </button>
        </div>

        {/* Right visual */}
        <div className="flex-1 flex justify-center lg:justify-end">
          <div className="relative w-72 h-96 md:w-80 md:h-[440px]">
            <div className="absolute inset-0 rounded-[40px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=sleek%20iOS%20smartphone%20mockup%20showing%20a%20clean%20modern%20app%20interface%20with%20shield%20icon%20and%20gradient%20cards%2C%20dark%20background%2C%20glowing%20screen%2C%20premium%20product%20photography%20style%2C%20minimalist%20UI%20visible%20on%20screen%2C%20soft%20ambient%20light%2C%20professional%20tech%20product%20shot%2C%20dark%20charcoal%20surroundings&width=400&height=560&seq=prima-phone-hero&orientation=portrait"
                alt="iOS app interface"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-4 -left-6 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 py-3">
              <p className="text-white text-xs font-medium">iOS Platform</p>
              <p className="text-white/60 text-xs">VPN &amp; Cleaner</p>
            </div>
            <div className="absolute -top-4 -right-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 py-3">
              <p className="text-white text-xs font-medium">Expert Team</p>
              <p className="text-white/60 text-xs">Bosnia &amp; Herzegovina</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-s-line text-white/40 text-lg" />
      </div>
    </section>
  );
}
